import Button, { buttonClassNames } from '@components/primitives/Button'
import { Icon } from '@components/primitives/Icon'
import { classMerge } from '@components/utilities/classMerge'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight'
import { type ApplySuccessPageProps } from 'app/p/apply-success/[token]/[step]/page'

export const PhoneCallAvailabilityButtonGroup = (
  _props: ApplySuccessPageProps,
) => {
  return (
    <div className='z-10 mx-8 flex w-full flex-row justify-end gap-2'>
      <Button
        className={classMerge(
          buttonClassNames.primary.black,
          'w-full rounded-full md:w-60',
        )}
        type='submit'
      >
        <p className='text-lg font-bold leading-[150%]'>Schedule Call</p>
        <Icon className='ml-2' icon={faArrowRight} />
      </Button>
    </div>
  )
}
